import { render, staticRenderFns } from "./ModalListaPrecio.vue?vue&type=template&id=4bce9bed"
import script from "./ModalListaPrecio.vue?vue&type=script&lang=js"
export * from "./ModalListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports